import type {Rec} from 'src/typings';
import type {ProjectFinancialOverviewDataService} from 'src/features/erp-sutor/features/project-financial-overview';
import type {FinishedResponseInteractionService} from 'shared/services';
import type {ProjectFinancialOverviewResponse} from 'src/features/erp-sutor/features/project-financial-overview/types';

export class ProjectFinancialOverviewService {
    public static serviceName = 'projectFinancialOverviewService';

    /*@ngInject*/
    constructor(private projectFinancialOverviewDataService: ProjectFinancialOverviewDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async getFinancialOverview(project: Rec): Promise<ProjectFinancialOverviewResponse> {
        try {
            return await this.projectFinancialOverviewDataService.getFinancialOverview(project);
        } catch (exceptionResponse) {
            this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
            throw exceptionResponse;
        }
    }
}